<template>
  <div class="balloon" @click="handleOpenNewTabWhatsapp">
    <v-icon color="white" size="35">mdi-whatsapp</v-icon>
  </div>
</template>

<script>
export default {
  methods: {
    handleOpenNewTabWhatsapp() {
      const phoneNumber = "554891964485";

      const isMobile = /Android|webOS|iPhone|BlackBerry|IEMobile/i.test(
        navigator.userAgent
      );

      if (isMobile) {
        window.location.href = `whatsapp://send?phone=${phoneNumber}`;
      } else {
        window.open(
          `https://web.whatsapp.com/send?phone=${phoneNumber}`,
          "_blank"
        );
      }
    },
  },
};
</script>

<style>
.balloon {
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  right: 10px;
  bottom: 70px;
  height: 50px;
  width: 50px;
  background-color: #25d366;
  z-index: 100000000000;
  border-radius: 40px;
  cursor: pointer;
}
</style>
